import { Button, Input } from "antd";
import React, { useState } from "react";
import isEqual from "react-fast-compare";

const PromptText = ({ data, handleEnter, aiInsightsLoader, id, aiLoader }) => {
  const [promptText, setpromptText] = useState({
    top_key: null,
    top_key_level_1: null,
    top_key_level_2: null,
    peak: null,
  });
  const handlePrompt = (e) => {
    let update_prompt = { ...promptText };
    update_prompt[id] = e?.target?.value;
    setpromptText(update_prompt);
  };
  return (
    <div
      className={`${id === "vally" || id === "peak" ? "ml-15 mr-15" : ""} ${
        aiLoader ? "disable" : ""
      } ${"d-flex"}`}
    >
      <div className={`mr-15 w-100 floating-label-group mt-1`}>
        <Input
          className="border-radius-4 border-color  mb-3"
          placeholder="Enter your prompt here"
          style={{ height: "3.5rem" }}
          value={
            promptText?.[id] === ""
              ? ""
              : promptText?.[id]
              ? promptText?.[id]
              : data
          }
          allowClear={true}
          onChange={(e) => handlePrompt(e)}
          onPressEnter={() => handleEnter(promptText?.[id], id)}
        />
        <label
          className="portlet-label floating-label ai_label font-size12"
          style={{
            zIndex: 1000,
            top: "-0.8rem",
          }}
        >
          Prompt
        </label>
      </div>
      <Button
        type="primary"
        className={`ant-btn-primary_blue mt-1 ${
          aiInsightsLoader?.value ? "disable" : ""
        }`}
        onClick={() => handleEnter(promptText?.[id], id)}
        //disabled={aiInsightsLoader?.value && "state-disabled"}
      >
        Refresh
      </Button>
    </div>
  );
};

export default React.memo(PromptText, isEqual);
